import axios from 'axios';

// Create an axios instance with default configuration
const axiosInstance = axios.create({
  baseURL: '/', // Base URL for API requests
  timeout: 10000, // Request timeout in milliseconds
  headers: {
    'Content-Type': 'application/json',
  },
});

// Add a response interceptor to standardize error handling
axiosInstance.interceptors.response.use(
  (response) => {
    // Any status code within the range of 2xx causes this function to trigger
    return response;
  },
  (error) => {
    // Any status codes outside the range of 2xx cause this function to trigger
    if (error.response) {
      // The request was made and the server responded with a status code
      // that falls out of the range of 2xx
      console.error('Response error:', error.response.data);
      
      // Check for authentication errors (401/403)
      if (error.response.status === 401 || error.response.status === 403) {
        console.warn('Authentication error detected, redirecting to login page');
        
        // Get the server error message to display to the user
        let errorMessage = 'Your session has expired. Please log in again.';
        
        // Try to extract the actual error message from the response
        if (error.response.data?.error) {
          if (typeof error.response.data.error === 'object') {
            errorMessage = error.response.data.error.message || errorMessage;
          } else {
            errorMessage = error.response.data.error;
          }
        }
        
        // Store the error message in sessionStorage so it can be displayed on the login page
        sessionStorage.setItem('auth_error_message', errorMessage);
        
        // Redirect to login page
        window.location.href = '/login?session_expired=true';
        
        // Return a special rejection that components can check for
        return Promise.reject({
          ...error,
          isAuthError: true,
          redirected: true,
          errorMessage
        });
      }
    } else if (error.request) {
      // The request was made but no response was received
      console.error('Request error:', error.request);
    } else {
      // Something happened in setting up the request that triggered an Error
      console.error('Error:', error.message);
    }
    
    // Pass the error along to be handled by the component
    return Promise.reject(error);
  }
);

export default axiosInstance;
